import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import FramePlayer from '../utils/FramePlayer';
import anime from 'animejs';
import lang from '../lang.json';

const audioA = new Audio(process.env.PUBLIC_URL + "/assets/sounds/Toots-motif-humain.wav");
const audioB = new Audio(process.env.PUBLIC_URL + "/assets/sounds/Toots-motif-avatar.wav");

const Toots = (props) => {

    const param = useParams();
    const [page, setPage] = useState(1);
    const langue = props.langue == "fr" ? "fr" : "en";

    const navigate = useNavigate();

    {/*for the menu*/ }
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const [showAnswer, setShowAnswer] = useState(false);
    const [pos1, setPos1] = useState(0);
    const [pos2, setPos2] = useState(0);

    const [cursorAPos, setCursorAPos] = useState(0);
    const cursorAPosRef = useRef(cursorAPos);
    const [cursorBPos, setCursorBPos] = useState(0);
    const cursorBPosRef = useRef(cursorBPos);

    const [rec1Hovered, setRec1Hovered] = useState(false);
    const [rec2Hovered, setRec2Hovered] = useState(false);
    const [rec3Hovered, setRec3Hovered] = useState(false);
    const [rec4Hovered, setRec4Hovered] = useState(false);
    const [rec5Hovered, setRec5Hovered] = useState(false);
    const [rec6Hovered, setRec6Hovered] = useState(false);
    const [rec7Hovered, setRec7Hovered] = useState(false);
    const [rec8Hovered, setRec8Hovered] = useState(false);
    const [rec9Hovered, setRec9Hovered] = useState(false);

    const clearAll = () => {
        // Get a reference to the last interval + 1
        const interval_id = window.setInterval(function () { }, Number.MAX_SAFE_INTEGER);

        // Clear any timeout/interval up to that id
        for (let i = 1; i < interval_id; i++) {
            window.clearInterval(i);
        }

        props.audio.forEach(audio => audio.pause());
    }

    const replay1 = () => {
        setShowAnswer(false);
        //Random head or tail
        const rand = Math.random();
        audioA.currentTime = 0;
        audioB.currentTime = 0;
        if (rand < 0.5) {
            setPos1(30);
            setPos2(350);
            
        }
        else {
            setPos1(350);
            setPos2(30);

        }
    }

    const [currentMotif, setCurrentMotif] = useState();
    const playMotif = (motif) => {
        if (currentMotif) {
            currentMotif.pause();
        }
        var audio = new Audio(process.env.PUBLIC_URL + `/assets/sounds/toots/${motif}.wav`);
        setCurrentMotif(audio);
        audio.play();
    }

    //concerning cursor A (human)
    const playA = () => {
        audioA.play();
    }

    const pauseA = () => {
        audioA.pause();
    }

    const backA = () => {
        audioA.currentTime = 0;
        audioA.pause();
    }

    const getPosA = () => {
        //Return the position between 0 and 620 of the cursor, proportionnaly to the current audio A time
        return (audioA.currentTime / audioA.duration) * 620;
    }

    //concerning cursor B (human)
    const playB = () => {
        audioB.play();
    }

    const pauseB = () => {
        audioB.pause();
    }

    const backB = () => {
        audioB.currentTime = 0;
        audioB.pause();
    }

    const getPosB = () => {
        //Return the position between 0 and 295 of the cursor, proportionnaly to the current audio A time
        return (audioB.currentTime / audioB.duration) * 295;
    }

    const pauseAll = () => {
        pauseA();
        pauseB();
    }

    //Set the position of the cursor A (human) and cursor B (avatar)
    useEffect(() => {
        setInterval(() => {
            cursorAPosRef.current = getPosA();
            setCursorAPos(cursorAPosRef.current);
            console.log("cursor A pos : " + cursorAPosRef.current);

            cursorBPosRef.current = getPosB();
            setCursorBPos(cursorBPosRef.current);
            console.log("cursor B pos : " + cursorBPosRef.current);
        }, 50);
    }, []);

    useEffect(() => {
        replay1();
    }, []);

    useEffect(() => {
        let pageNumber;

        switch (param.page) {
            case '1-test':
                pageNumber = 1;
                break;
            case '2-video':
                pageNumber = 2;
                break;
            case '3-motives':
                pageNumber = 3;
                break;
            default:
                pageNumber = 0;
        }
        setPage(pageNumber);
        console.log("page is now : " + pageNumber);

        if (pageNumber === 0) {
            window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur' + '/toots/';
            //navigate(process.env.PUBLIC_URL + '/toots/1-test/');
            setPage(1);
        }

    }, [param.page]);

    return (
        <>
            <div className="background" />

            {/* page 1 */}
            {
                page === 1 &&
                <>
                    <img
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                            width: '660px',
                            height: '500px',
                        }}
                        src={process.env.PUBLIC_URL + "/assets/images/toots/background.png"}
                    />
                    <h2
                        style={{
                            position: 'absolute',
                            top: '5px',
                            left: '25px',
                            color: 'white',
                            fontSize: '16px',
                            margin: 0,
                        }}
                    >
                        {langue === "fr" &&
                            <>AVATAR DE TOOTS THIELEMANS : test vrai ou faux</>}
                        {langue === "en" &&
                            <>TOOTS THIELEMANS' AVATAR : real or fake test</>}
                    </h2>
                    <p
                        style={{
                            position: 'absolute',
                            top: '27px',
                            width: '625px',
                            left: '25px',
                            color: 'white',
                            fontSize: '14px',
                            margin: 0,
                        }}
                    >
                        {langue === "fr" &&
                            <>L'un de ces extraits est un vrai solo de Toots Thielemans, l'autre est un avatar généré par le
                                logiciel d'improvisation Djazz (Marc Chemillier, Mikhail Malt) avec l'harmonica obtenu par
                                séparation des sources (Shlomo Dubnov, Ke Chen).
                                Quel est le vrai Toots, quel est le faux ?</>}
                        {langue === "en" &&
                            <>One of these extracts is a real Toots Thielemans solo, the other is an avatar generated by
                                Djazz improvisation software (Marc Chemillier, Mikhail Malt) with source-separated
                                harmonica (Shlomo Dubnov, Ke Chen).
                                Which is the real Toots, which is the fake?</>}
                    </p>

                    {/* 2 vidéos */}
                    <video
                        style={{
                            position: 'absolute',
                            top: '120px',
                            left: pos1,
                            width: '280px',
                            display: showAnswer ? 'none' : 'block',
                        }}
                        src={process.env.PUBLIC_URL + "/assets/movies/toots11.mp4"}
                        controls
                    />
                    <img
                        style={{
                            position: 'absolute',
                            top: '120px',
                            left: pos1 + 20,
                            width: '240px',
                            display: showAnswer ? 'block' : 'none',
                        }}
                        src={process.env.PUBLIC_URL + "/assets/images/toots/logo-not-toots.png"}
                    />
                    <h2
                        style={{
                            position: 'absolute',
                            top: '345px',
                            left: pos1 + 20,
                            width: '240px',
                            fontSize: '30px',
                            fontFamily: 'Arial',
                            fontWeight: 'bold',
                            color: 'white',
                            textAlign: 'center',
                            display: showAnswer ? 'block' : 'none',
                        }}
                    >
                        {langue === "fr" &&
                            <>Pas Toots</>
                        }
                        {langue === "en" &&
                            <>Not Toots</>
                        }
                    </h2>
                    <video
                        style={{
                            position: 'absolute',
                            top: '120px',
                            left: pos2,
                            width: '280px',
                            display: showAnswer ? 'none' : 'block',
                        }}
                        src={process.env.PUBLIC_URL + "/assets/movies/toots12.mp4"}
                        controls
                    />
                    <img
                        style={{
                            position: 'absolute',
                            top: '120px',
                            left: pos2 + 20,
                            width: '240px',
                            display: showAnswer ? 'block' : 'none',
                        }}
                        src={process.env.PUBLIC_URL + "/assets/images/toots/logo-toots.png"}
                    />
                    <h2
                        style={{
                            position: 'absolute',
                            top: '345px',
                            left: pos2 + 20,
                            width: '240px',
                            fontSize: '30px',
                            fontFamily: 'Arial',
                            fontWeight: 'bold',
                            color: 'white',
                            textAlign: 'center',
                            display: showAnswer ? 'block' : 'none',
                        }}
                    >
                        Toots
                    </h2>
                    <h2
                        style={{
                            position: 'absolute',
                            top: '465px',
                            left: '30px',
                            color: 'white',
                            fontSize: '16px',
                            margin: 0,
                            cursor: 'pointer',
                            display: showAnswer ? 'none' : 'block',
                            userSelect: 'none',
                        }}
                        onClick={() => {
                            setShowAnswer(true);
                        }}
                    >
                        {langue === "fr" &&
                            <>RÉPONSE</>}
                        {langue === "en" &&
                            <>ANSWER</>}
                    </h2>
                    <h2
                        style={{
                            position: 'absolute',
                            top: '465px',
                            left: '30px',
                            color: 'red',
                            fontSize: '16px',
                            margin: 0,
                            cursor: 'pointer',
                            display: showAnswer ? 'block' : 'none',
                            userSelect: 'none',
                        }}
                        onClick={() => {
                            backA();//PB2 replay
                            backB();
                            replay1();
                        }}
                    >
                        {langue === "fr" &&
                            <>REJOUER</>}
                        {langue === "en" &&
                            <>REPLAY</>}
                    </h2>
                </>
            }

            {/* page 2 */}
            {page === 2 &&
                <>
                    <h2
                        style={{
                            position: 'absolute',
                            top: '5px',
                            left: '20px',
                            color: 'white',
                            fontSize: '16px',
                            margin: 0,
                        }}
                    >
                        {langue === "fr" &&
                            <>AVATAR DE TOOTS THIELEMANS : vidéo</>}
                        {langue === "en" &&
                            <>TOOTS THIELEMANS' AVATAR : video</>}
                    </h2>
                    <p
                        style={{
                            position: 'absolute',
                            top: '27px',
                            width: '625px',
                            left: '20px',
                            color: 'white',
                            fontSize: '14px',
                            margin: 0,
                        }}
                    >
                        {langue === "fr" &&
                            <>Improvisation de l'avatar par Marc Chemillier contrôlant le logiciel Djazz. Les touches en haut
                                du pad de contrôle symbolisent la grille harmonique. Les autres sont des effets de changement
                                de mémoire, bouclage, accélération.</>}
                        {langue === "en" &&
                            <>Marc Chemillier's improvisation of the avatar controlling the Djazz software. The upper keys
                                of the control pad symbolize the chord progression of the tune. The others are memory change,
                                looping and acceleration effects.</>}
                    </p>

                    <video
                        style={{
                            position: 'absolute',
                            top: '110px',
                            left: '231px',
                            height: '350px',
                        }}
                        src={process.env.PUBLIC_URL + "/assets/movies/toots2.mp4"}
                        controls
                    />
                </>
            }

            {/* page 3 */}
            {page === 3 &&
                <>
                    <h2
                        style={{
                            position: 'absolute',
                            top: '5px',
                            left: '20px',
                            color: 'white',
                            fontSize: '16px',
                            margin: 0,
                        }}
                    >
                        {langue === "fr" &&
                            <>AVATAR DE TOOTS THIELEMANS : recombinaison de motifs</>}
                        {langue === "en" &&
                            <>TOOTS THIELEMANS' AVATAR : pattern recombination</>}
                    </h2>
                    <p
                        style={{
                            position: 'absolute',
                            top: '27px',
                            width: '625px',
                            left: '20px',
                            color: 'white',
                            fontSize: '14px',
                            margin: 0,
                            zIndex: 3,
                        }}
                    >
                        {langue === "fr" &&
                            <>Le solo d'harmonica généré par l'<span style={{ color: 'red' }}>avatar</span> (en bas) recombine des motifs pris dans le solo <span style={{ color: '#1600FF' }}>humain </span>
                                de Toots Thielemans (en haut) dans l'album Affinity avec Bill Evans (Body And Soul).</>}
                        {langue === "en" &&
                            <>The harmonica solo generated by the <span style={{ color: 'red' }}>avatar</span> (bottom) recombines motifs from the <span style={{ color: '#1600FF' }}>human</span>  solo of
                                Toots Thielemans (top) in the album Affinity with Bill Evans (Body And Soul).</>}
                    </p>

                    <img
                        style={{
                            position: 'absolute',
                            top: '30px',
                            left: '0px',
                            width: '660px',
                            zIndex: 2,
                        }}
                        src={process.env.PUBLIC_URL + "/assets/images/toots/motifs.png"}
                    />
                    <h2
                        style={{
                            position: 'absolute',
                            top: '85px',
                            left: '576px',
                            color: '#1600FF', //PB5 color
                            fontSize: '16px',
                            zIndex: 5,
                            margin: 0,
                        }}
                    >
                        {langue === "fr" &&
                            <>HUMAIN</>}
                        {langue === "en" &&
                            <>HUMAN</>}
                    </h2>
                    <h2
                        style={{
                            position: 'absolute',
                            top: '272px',
                            left: '254px',
                            color: 'red',
                            fontSize: '16px',
                            zIndex: 5,
                            margin: 0,
                        }}
                    >
                        {langue === "fr" &&
                            <>AVATAR</>}
                        {langue === "en" &&
                            <>AVATAR</>}
                    </h2>

                    {/* rectangles */}
                    <div
                        id="human-1"
                        style={{
                            position: 'absolute',
                            top: 135,
                            left: 25,
                            width: 30,
                            height: 79,
                            zIndex: 14,
                            backgroundColor: '#ffb833',
                            opacity: rec1Hovered ? 0.5 : 0,
                            cursor: 'pointer',
                        }}
                        onMouseEnter={() => {
                            setRec1Hovered(true);
                        }}
                        onMouseLeave={() => {
                            setRec1Hovered(false);
                        }}
                        onClick={() => {
                            //play wav audio
                            playMotif('tootsmotif1-A1-humain')
                        }}
                    />
                    <div
                        id="human-2"
                        style={{
                            position: 'absolute',
                            top: 124,
                            left: 531,
                            width: 40,
                            height: 102,
                            zIndex: 14,
                            backgroundColor: '#ffb833',
                            opacity: rec2Hovered ? 0.5 : 0,
                            cursor: 'pointer',
                        }}
                        onMouseEnter={() => {
                            setRec2Hovered(true);
                        }}
                        onMouseLeave={() => {
                            setRec2Hovered(false);
                        }}
                        onClick={() => {
                            //play wav audio
                            playMotif('tootsmotif2-A3-humain')
                        }}
                    />
                    <div
                        id="human-3"
                        style={{
                            position: 'absolute',
                            top: 113,
                            left: 254,
                            width: 43,
                            height: 121,
                            zIndex: 14,
                            backgroundColor: '#ffb833',
                            opacity: rec3Hovered ? 0.5 : 0,
                            cursor: 'pointer',
                        }}
                        onMouseEnter={() => {
                            setRec3Hovered(true);
                        }}
                        onMouseLeave={() => {
                            setRec3Hovered(false);
                        }}
                        onClick={() => {
                            //play wav audio
                            playMotif('tootsmotif3-A2-humain')
                        }}
                    />
                    <div
                        id="human-4"
                        style={{
                            position: 'absolute',
                            top: 119,
                            left: 144,
                            width: 10,
                            height: 99,
                            zIndex: 14,
                            backgroundColor: '#ffb833',
                            opacity: rec4Hovered ? 0.5 : 0,
                            cursor: 'pointer',
                        }}
                        onMouseEnter={() => {
                            setRec4Hovered(true);
                        }}
                        onMouseLeave={() => {
                            setRec4Hovered(false);
                        }}
                        onClick={() => {
                            //play wav audio
                            playMotif('tootsmotif4-A1-humain')
                        }}
                    />
                    <div
                        id="human-5"
                        style={{
                            position: 'absolute',
                            top: 134,
                            left: 487,
                            width: 12,
                            height: 79,
                            zIndex: 15,
                            backgroundColor: '#ffb833',
                            opacity: rec5Hovered ? 0.5 : 0,
                            cursor: 'pointer',
                        }}
                        onMouseEnter={() => {
                            setRec5Hovered(true);
                        }}
                        onMouseLeave={() => {
                            setRec5Hovered(false);
                        }}
                        onClick={() => {
                            //play wav audio
                            playMotif('tootsmotif5-A3-humain')
                        }}
                    />
                    <div
                        id="human-6"
                        style={{
                            position: 'absolute',
                            top: 119,
                            left: 210,
                            width: 30,
                            height: 116,
                            zIndex: 16,
                            backgroundColor: '#ffb833',
                            opacity: rec6Hovered ? 0.5 : 0,
                            cursor: 'pointer',
                        }}
                        onMouseEnter={() => {
                            setRec6Hovered(true);
                        }}
                        onMouseLeave={() => {
                            setRec6Hovered(false);
                        }}
                        onClick={() => {
                            //play wav audio
                            playMotif('tootsmotif6-A2-humain')
                        }}
                    />

                    <div
                        id="human-7"
                        style={{
                            position: 'absolute',
                            top: 140,
                            left: 94,
                            width: 13,
                            height: 75,
                            zIndex: 17,
                            backgroundColor: '#ffb833',
                            opacity: rec7Hovered ? 0.5 : 0,
                            cursor: 'pointer',
                        }}
                        onMouseEnter={() => {
                            setRec7Hovered(true);
                        }}
                        onMouseLeave={() => {
                            setRec7Hovered(false);
                        }}
                        onClick={() => {
                            //play wav audio
                            playMotif('tootsmotif7-A1-humain')
                        }}
                    />

                    <div
                        id="human-8"
                        style={{
                            position: 'absolute',
                            top: 124,
                            left: 604,
                            width: 16,
                            height: 103,
                            zIndex: 18,
                            backgroundColor: '#ffb833',
                            opacity: rec8Hovered ? 0.5 : 0,
                            cursor: 'pointer',
                        }}
                        onMouseEnter={() => {
                            setRec8Hovered(true);
                        }}
                        onMouseLeave={() => {
                            setRec8Hovered(false);
                        }}
                        onClick={() => {
                            //play wav audio
                            playMotif('tootsmotif8-A3-humain')
                        }}
                    />

                    <div
                        id="human-9"
                        style={{
                            position: 'absolute',
                            top: 112,
                            left: 279,
                            width: 19,
                            height: 127,
                            zIndex: 12,
                            backgroundColor: '#ffb833',
                            opacity: rec9Hovered ? 0.5 : 0,
                            cursor: 'pointer',
                        }}
                        onMouseEnter={() => {
                            setRec9Hovered(true);
                        }}
                        onMouseLeave={() => {
                            setRec9Hovered(false);
                        }}
                        onClick={() => {
                            //play wav audio
                            playMotif('tootsmotif9-A2-humain')
                        }}
                    />

                    <div
                        id="avatar-1"
                        style={{
                            position: 'absolute',
                            top: 323,
                            left: 25,
                            width: 30,
                            height: 79,
                            zIndex: 14,
                            backgroundColor: '#ffb833',
                            opacity: rec1Hovered ? 0.5 : 0,
                            cursor: 'pointer',
                        }}
                        onMouseEnter={() => {
                            setRec1Hovered(true);
                        }}
                        onMouseLeave={() => {
                            setRec1Hovered(false);
                        }}
                        onClick={() => {
                            //play wav audio
                            playMotif('tootsmotif1-avatar')
                        }}
                    />
                    <div
                        id="avatar-2"
                        style={{
                            position: 'absolute',
                            top: 311,
                            left: 57,
                            width: 40,
                            height: 102,
                            zIndex: 14,
                            backgroundColor: '#ffb833',
                            opacity: rec2Hovered ? 0.5 : 0,
                            cursor: 'pointer',
                        }}
                        onMouseEnter={() => {
                            setRec2Hovered(true);
                        }}
                        onMouseLeave={() => {
                            setRec2Hovered(false);
                        }}
                        onClick={() => {
                            //play wav audio
                            playMotif('tootsmotif2-avatar')
                        }}
                    />
                    <div
                        id="avatar-3"
                        style={{
                            position: 'absolute',
                            top: 304,
                            left: 99,
                            width: 43,
                            height: 121,
                            zIndex: 14,
                            backgroundColor: '#ffb833',
                            opacity: rec3Hovered ? 0.5 : 0,
                            cursor: 'pointer',
                        }}
                        onMouseEnter={() => {
                            setRec3Hovered(true);
                        }}
                        onMouseLeave={() => {
                            setRec3Hovered(false);
                        }}
                        onClick={() => {
                            //play wav audio
                            playMotif('tootsmotif3-avatar')
                        }}
                    />
                    <div
                        id="avatar-3-m"
                        style={{
                            position: 'absolute',
                            top: 304,
                            left: 108,
                            width: 8,
                            height: 121,
                            zIndex: 14,
                            backgroundColor: '#73551d',
                            opacity: rec3Hovered ? 0.5 : 0,
                            cursor: 'pointer',
                        }}
                        onMouseEnter={() => {
                            setRec3Hovered(true);
                        }}
                        onMouseLeave={() => {
                            setRec3Hovered(false);
                        }}
                        onClick={() => {
                            //play wav audio
                            playMotif('tootsmotif3-avatar')
                        }}
                    />
                    <div
                        id="avatar-4"
                        style={{
                            position: 'absolute',
                            top: 317,
                            left: 144,
                            width: 9,
                            height: 99,
                            zIndex: 14,
                            backgroundColor: '#ffb833',
                            opacity: rec4Hovered ? 0.5 : 0,
                            cursor: 'pointer',
                        }}
                        onMouseEnter={() => {
                            setRec4Hovered(true);
                        }}
                        onMouseLeave={() => {
                            setRec4Hovered(false);
                        }}
                        onClick={() => {
                            //play wav audio
                            playMotif('tootsmotif4-avatar')
                        }}
                    />
                    <div
                        id="avatar-4-m"
                        style={{
                            position: 'absolute',
                            top: 317,
                            left: 153,
                            width: 19,
                            height: 99,
                            zIndex: 14,
                            backgroundColor: '#73551d',
                            opacity: rec4Hovered ? 0.5 : 0,
                            cursor: 'pointer',
                        }}
                        onMouseEnter={() => {
                            setRec4Hovered(true);
                        }}
                        onMouseLeave={() => {
                            setRec4Hovered(false);
                        }}
                        onClick={() => {
                            //play wav audio
                            playMotif('tootsmotif4-avatar')
                        }}
                    />
                    <div
                        id="avatar-5"
                        style={{
                            position: 'absolute',
                            top: 323,
                            left: 174,
                            width: 12,
                            height: 78,
                            zIndex: 15,
                            backgroundColor: '#ffb833',
                            opacity: rec5Hovered ? 0.5 : 0,
                            cursor: 'pointer',
                        }}
                        onMouseEnter={() => {
                            setRec5Hovered(true);
                        }}
                        onMouseLeave={() => {
                            setRec5Hovered(false);
                        }}
                        onClick={() => {
                            //play wav audio
                            playMotif('tootsmotif5-avatar')
                        }}
                    />
                    <div
                        id="avatar-5-m"
                        style={{
                            position: 'absolute',
                            top: 323,
                            left: 186,
                            width: 22,
                            height: 78,
                            zIndex: 15,
                            backgroundColor: '#73551d',
                            opacity: rec5Hovered ? 0.5 : 0,
                            cursor: 'pointer',
                        }}
                        onMouseEnter={() => {
                            setRec5Hovered(true);
                        }}
                        onMouseLeave={() => {
                            setRec5Hovered(false);
                        }}
                        onClick={() => {
                            //play wav audio
                            playMotif('tootsmotif5-avatar')
                        }}
                    />
                    <div
                        id="avatar-6"
                        style={{
                            position: 'absolute',
                            top: 306,
                            left: 210,
                            width: 29,
                            height: 116,
                            zIndex: 16,
                            backgroundColor: '#ffb833',
                            opacity: rec6Hovered ? 0.5 : 0,
                            cursor: 'pointer',
                        }}
                        onMouseEnter={() => {
                            setRec6Hovered(true);
                        }}
                        onMouseLeave={() => {
                            setRec6Hovered(false);
                        }}
                        onClick={() => {
                            //play wav audio
                            playMotif('tootsmotif6-avatar')
                        }}
                    />

                    <div
                        id="avatar-7"
                        style={{
                            position: 'absolute',
                            top: 326,
                            left: 244,
                            width: 13,
                            height: 75,
                            zIndex: 17,
                            backgroundColor: '#ffb833',
                            opacity: rec7Hovered ? 0.5 : 0,
                            cursor: 'pointer',
                        }}
                        onMouseEnter={() => {
                            setRec7Hovered(true);
                        }}
                        onMouseLeave={() => {
                            setRec7Hovered(false);
                        }}
                        onClick={() => {
                            //play wav audio
                            playMotif('tootsmotif7-avatar')
                        }}
                    />

                    <div
                        id="avatar-8"
                        style={{
                            position: 'absolute',
                            top: 309,
                            left: 260,
                            width: 16,
                            height: 103,
                            zIndex: 18,
                            backgroundColor: '#ffb833',
                            opacity: rec8Hovered ? 0.5 : 0,
                            cursor: 'pointer',
                        }}
                        onMouseEnter={() => {
                            setRec8Hovered(true);
                        }}
                        onMouseLeave={() => {
                            setRec8Hovered(false);
                        }}
                        onClick={() => {
                            //play wav audio
                            playMotif('tootsmotif8-avatar')
                        }}
                    />

                    <div
                        id="avatar-9"
                        style={{
                            position: 'absolute',
                            top: 298,
                            left: 277,
                            width: 19,
                            height: 127,
                            zIndex: 19,
                            backgroundColor: '#ffb833',
                            opacity: rec9Hovered ? 0.5 : 0,
                            cursor: 'pointer',
                        }}
                        onMouseEnter={() => {
                            setRec9Hovered(true);
                        }}
                        onMouseLeave={() => {
                            setRec9Hovered(false);
                        }}
                        onClick={() => {
                            //play wav audio
                            playMotif('tootsmotif9-avatar')
                        }}
                    />
                    <div
                        id="avatar-9-m"
                        style={{
                            position: 'absolute',
                            top: 298,
                            left: 296,
                            width: 23,
                            height: 127,
                            zIndex: 19,
                            backgroundColor: '#73551d',
                            opacity: rec9Hovered ? 0.5 : 0,
                            cursor: 'pointer',
                        }}
                        onMouseEnter={() => {
                            setRec9Hovered(true);
                        }}
                        onMouseLeave={() => {
                            setRec9Hovered(false);
                        }}
                        onClick={() => {
                            //play wav audio
                            playMotif('tootsmotif9-avatar')
                        }}
                    />


                    {/* controls A */}
                    <div
                        style={{
                            position: 'absolute',
                            top: 254,
                            left: 36,
                            width: 200,
                            height: 30,
                            zIndex: 10,
                        }}
                    >
                        {/* play A */}
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/toots/play.png"}
                            style=
                            {{
                                position: 'absolute',
                                top: '0px',
                                left: '0px',
                                cursor: 'pointer',
                            }}
                            //Change source to play_a.png when hovered
                            onMouseEnter={(e) => {
                                e.target.src = process.env.PUBLIC_URL + "/assets/images/toots/play_a.png"
                            }}
                            onMouseLeave={(e) => {
                                e.target.src = process.env.PUBLIC_URL + "/assets/images/toots/play.png"
                            }}
                            onClick={() => {
                                playA()
                            }}
                        />
                        {/* pause A */}
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/toots/pause.png"}
                            style=
                            {{
                                position: 'absolute',
                                top: '0px',
                                left: '20px',
                                cursor: 'pointer',
                            }}
                            //Change source to pause_a.png when hovered
                            onMouseEnter={(e) => {
                                e.target.src = process.env.PUBLIC_URL + "/assets/images/toots/pause_a.png"
                            }}
                            onMouseLeave={(e) => {
                                e.target.src = process.env.PUBLIC_URL + "/assets/images/toots/pause.png"
                            }}
                            onClick={() => {
                                pauseA()
                            }}
                        />
                        {/* back A */}
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/toots/back.png"}
                            style=
                            {{
                                position: 'absolute',
                                top: '0px',
                                left: '40px',
                                cursor: 'pointer',
                            }}
                            //Change source to back_a.png when hovered
                            onMouseEnter={(e) => {
                                e.target.src = process.env.PUBLIC_URL + "/assets/images/toots/back_a.png"
                            }}
                            onMouseLeave={(e) => {
                                e.target.src = process.env.PUBLIC_URL + "/assets/images/toots/back.png"
                            }}
                            onClick={() => {
                                backA()
                            }}
                        />
                    </div>

                    {/* cursor A */}
                    <svg
                        style={{
                            position: 'absolute',
                            top: '105px',
                            left: '25px',
                            width: '623px',
                            height: '141px',
                            zIndex: 10,
                        }}
                    >
                        <line
                            x1={cursorAPosRef.current}
                            y1="0"
                            x2={cursorAPosRef.current}
                            y2="141"
                            stroke="red"
                            strokeWidth="2"
                        />
                    </svg>

                    {/* controls B */}
                    <div
                        style={{
                            position: 'absolute',
                            top: 443,
                            left: 36,
                            width: 200,
                            height: 30,
                            zIndex: 10,
                        }}
                    >
                        {/* play B */}
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/toots/play.png"}
                            style=
                            {{
                                position: 'absolute',
                                top: '0px',
                                left: '0px',
                                cursor: 'pointer',
                            }}
                            //Change source to play_a.png when hovered
                            onMouseEnter={(e) => {
                                e.target.src = process.env.PUBLIC_URL + "/assets/images/toots/play_a.png"
                            }}
                            onMouseLeave={(e) => {
                                e.target.src = process.env.PUBLIC_URL + "/assets/images/toots/play.png"
                            }}
                            onClick={() => {
                                playB()
                            }}
                        />
                        {/* pause B */}
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/toots/pause.png"}
                            style=
                            {{
                                position: 'absolute',
                                top: '0px',
                                left: '20px',
                                cursor: 'pointer',
                            }}
                            //Change source to pause_a.png when hovered
                            onMouseEnter={(e) => {
                                e.target.src = process.env.PUBLIC_URL + "/assets/images/toots/pause_a.png"
                            }}
                            onMouseLeave={(e) => {
                                e.target.src = process.env.PUBLIC_URL + "/assets/images/toots/pause.png"
                            }}
                            onClick={() => {
                                pauseB()
                            }}
                        />
                        {/* back B */}
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/toots/back.png"}
                            style=
                            {{
                                position: 'absolute',
                                top: '0px',
                                left: '40px',
                                cursor: 'pointer',
                            }}
                            //Change source to back_a.png when hovered
                            onMouseEnter={(e) => {
                                e.target.src = process.env.PUBLIC_URL + "/assets/images/toots/back_a.png"
                            }}
                            onMouseLeave={(e) => {
                                e.target.src = process.env.PUBLIC_URL + "/assets/images/toots/back.png"
                            }}
                            onClick={() => {
                                backB()
                            }}
                        />
                    </div>

                    {/* cursor B */}
                    <svg
                        style={{
                            position: 'absolute',
                            top: '294px',
                            left: '25px',
                            width: '295px',
                            height: '138px',
                            zIndex: 10,
                        }}
                    >
                        <line
                            x1={cursorBPosRef.current}
                            y1="0"
                            x2={cursorBPosRef.current}
                            y2="138"
                            stroke="red"
                            strokeWidth="2"
                        />
                    </svg>
                </>
            }

            {/* nav */} 
            <div
                style={{
                    position: 'absolute',//PB4
                    top: '457px',
                    left: '420px',
                    zIndex: 17,
                }}
                id="nav"
            >
                <div
                    onMouseLeave={() => {
                        setIsMenuOpen(false);
                    }}
                    style={{
                        cursor: 'pointer',
                    }}
                >
                    <div
                        className='inflateButtonTiny'
                        onMouseEnter={() => {
                            setIsMenuOpen(true);
                        }}

                    >
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/nav/4.png"}
                            style={{ position: 'absolute', top: '10px', left: '0px' }}
                        />
                        <p
                            style={{
                                position: 'absolute',
                                top: '0px',
                                left: '40px',
                                width: '180px',
                                color: 'yellow',
                                fontSize: '16px',
                                userSelect: 'none',
                            }}
                        >
                            {langue === "fr" ? "Aller à..." : "go to..."}
                        </p>
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            top: '-90px',
                            left: '35px',
                            width: '180px',
                            zIndex: 18,
                            display: isMenuOpen ? 'block' : 'none',
                        }}
                        onMouseLeave={() => { setIsMenuOpen(false); }}
                    >
                        <div
                            style={{
                                backgroundColor: "rgb(63, 102, 85)",
                                width: "100%",
                                borderTopRightRadius: "0px",
                                borderBottomRightRadius: "0px",
                            }}
                            onMouseEnter={
                                (e) => {
                                    e.target.parentNode.style.width = "100%";
                                    e.target.parentNode.style.borderTopRightRadius = "10px";
                                    e.target.parentNode.style.borderBottomRightRadius = "10px";
                                }
                            }
                            onMouseLeave={
                                (e) => {
                                    e.target.parentNode.style.width = "90%";
                                    e.target.parentNode.style.borderTopRightRadius = "0px";
                                    e.target.parentNode.style.borderBottomRightRadius = "0px";
                                }
                            }
                            onClick={
                                () => {
                                    pauseAll();
                                    window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur' + '/menu/';
                                    //navigate(process.env.PUBLIC_URL + '/menu/');
                                }
                            }
                        >
                            <p className="numberLabel"
                                style={{
                                    color: "black",
                                    margin: 0,
                                    fontSize: 16, //modification de la taille
                                    width: "100%",
                                    userSelect: "none"
                                }} >
                                ACCUEIL
                            </p>
                        </div>
                        <div
                            style={{
                                backgroundColor: "rgb(101, 120, 108)",
                                width: "90%",
                                borderTopRightRadius: "0px",
                                borderBottomRightRadius: "0px",
                            }}
                            onMouseEnter={
                                (e) => {
                                    e.target.parentNode.style.width = "100%";
                                    e.target.parentNode.style.borderTopRightRadius = "10px";
                                    e.target.parentNode.style.borderBottomRightRadius = "10px";
                                }
                            }
                            onMouseLeave={
                                (e) => {
                                    e.target.parentNode.style.width = "90%";
                                    e.target.parentNode.style.borderTopRightRadius = "0px";
                                    e.target.parentNode.style.borderBottomRightRadius = "0px";
                                }
                            }
                            onClick={
                                () => {
                                    pauseAll();
                                    window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur' + '/menudida/';
                                    //navigate(process.env.PUBLIC_URL + '/menudida/');
                                }
                            }
                        >
                            <p className="numberLabel"
                                style={{
                                    color: "black",
                                    margin: 0,
                                    fontSize: 16,
                                    width: "100%",
                                    userSelect: "none"
                                }} >
                                DIDACTIQUE
                            </p>
                        </div>
                        <div
                            style={{
                                backgroundColor: "rgb(63, 102, 85)",
                                width: "90%",
                                borderTopRightRadius: "0px",
                                borderBottomRightRadius: "0px",
                            }}
                            onMouseEnter={
                                (e) => {
                                    e.target.parentNode.style.width = "100%";
                                    e.target.parentNode.style.borderTopRightRadius = "10px";
                                    e.target.parentNode.style.borderBottomRightRadius = "10px";
                                }
                            }
                            onMouseLeave={
                                (e) => {
                                    e.target.parentNode.style.width = "90%";
                                    e.target.parentNode.style.borderTopRightRadius = "0px";
                                    e.target.parentNode.style.borderBottomRightRadius = "0px";
                                }
                            }
                            onClick={
                                () => {
                                    pauseAll();
                                    window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur' + '/menumusic/';
                                    //navigate(process.env.PUBLIC_URL + '/menumusic/');
                                }
                            }
                        >
                            <p className="numberLabel"
                                style={{
                                    color: "black",
                                    margin: 0,
                                    fontSize: 16,
                                    width: "100%",
                                    userSelect: "none"
                                }} >
                                MUSICAL
                            </p>
                        </div>
                        <div
                            style={{
                                backgroundColor: page === 1 ? "#2ea8d8" : "rgb(101, 120, 108)",
                                width: page === 1 ? "100%" : "90%",
                                borderTopRightRadius: page === 1 ? "10px" : "0px",
                                borderBottomRightRadius: page === 1 ? "10px" : "0px",
                            }}
                            onMouseEnter={
                                (e) => {
                                    e.target.parentNode.style.width = "100%";
                                    e.target.parentNode.style.borderTopRightRadius = "10px";
                                    e.target.parentNode.style.borderBottomRightRadius = "10px";
                                }
                            }
                            onMouseLeave={
                                (e) => {
                                    e.target.parentNode.style.width = page === 1 ? "100%" : "90%";
                                    e.target.parentNode.style.borderTopRightRadius = page === 1 ? "10px" : "0px";
                                    e.target.parentNode.style.borderBottomRightRadius = page === 1 ? "10px" : "0px";
                                }
                            }
                            onClick={
                                () => {
                                    pauseAll();
                                    window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur' + '/toots/';
                                    
                                    //navigate(process.env.PUBLIC_URL + '/toots/1-test/');
                                }
                            }
                        >
                            <p className="numberLabel"
                                style={{
                                    color: "black",
                                    margin: 0,
                                    fontSize: 16,
                                    width: "100%",
                                    userSelect: "none"
                                }} >
                                test
                            </p>
                        </div>
                        <div
                            style={{
                                backgroundColor: page === 2 ? "#2ea8d8" : "rgb(101, 120, 108)",
                                width: page === 2 ? "100%" : "90%",
                                borderTopRightRadius: page === 2 ? "10px" : "0px",
                                borderBottomRightRadius: page === 2 ? "10px" : "0px",
                            }}
                            onMouseEnter={
                                (e) => {
                                    e.target.parentNode.style.width = "100%";
                                    e.target.parentNode.style.borderTopRightRadius = "10px";
                                    e.target.parentNode.style.borderBottomRightRadius = "10px";
                                }
                            }
                            onMouseLeave={
                                (e) => {
                                    e.target.parentNode.style.width = page === 2 ? "100%" : "90%";
                                    e.target.parentNode.style.borderTopRightRadius = page === 2 ? "10px" : "0px";
                                    e.target.parentNode.style.borderBottomRightRadius = page === 2 ? "10px" : "0px";
                                }
                            }
                            onClick={
                                () => {
                                    pauseAll();
                                    window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur' + '/toots/2-video/';
                                    //navigate(process.env.PUBLIC_URL + '/toots/2-video/');
                                }
                            }
                        >
                            <p className="numberLabel"
                                style={{
                                    color: "black",
                                    margin: 0,
                                    fontSize: 16,
                                    width: "100%",
                                    userSelect: "none"
                                }} >
                                vidéos
                            </p>
                        </div>
                        <div
                            style={{
                                backgroundColor: page === 3 ? "#2ea8d8" : "rgb(101, 120, 108)",
                                width: page === 3 ? "100%" : "90%",
                                borderTopRightRadius: page === 3 ? "10px" : "0px",
                                borderBottomRightRadius: page === 3 ? "10px" : "0px",
                            }}
                            onMouseEnter={
                                (e) => {
                                    e.target.parentNode.style.width = "100%";
                                    e.target.parentNode.style.borderTopRightRadius = "10px";
                                    e.target.parentNode.style.borderBottomRightRadius = "10px";
                                }
                            }
                            onMouseLeave={
                                (e) => {
                                    e.target.parentNode.style.width = page === 3 ? "100%" : "90%";
                                    e.target.parentNode.style.borderTopRightRadius = page === 3 ? "10px" : "0px";
                                    e.target.parentNode.style.borderBottomRightRadius = page === 3 ? "10px" : "0px";
                                }
                            }
                            onClick={
                                () => {
                                    pauseAll();
                                    window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur/toots/3-motives/';
                                    //navigate(process.env.PUBLIC_URL + '/toots/3-motives/');
                                }
                            }
                        >
                            <p className="numberLabel"
                                style={{
                                    color: "black",
                                    margin: 0,
                                    fontSize: 16,
                                    width: "100%",
                                    userSelect: "none"
                                }} >
                                motifs
                            </p>
                        </div>
                    </div>
                </div>
                <img
                    src={process.env.PUBLIC_URL + "/assets/images/nav/2.png"}
                    style={{
                        position: 'absolute',
                        top: '-2px',
                        left: '122px',
                        cursor: 'pointer',
                        display: page === 1 ? 'none' : 'block',
                    }}
                    className='inflateButtonMore'
                    onClick={
                        () => {
                            pauseAll();
                            //previous
                            if (page === 2) {
                                window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur' + '/toots/';
                                //navigate(process.env.PUBLIC_URL + '/toots/1-test/');
                            } else if (page === 3) {
                                window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur' + '/toots/2-video/';
                                //navigate(process.env.PUBLIC_URL + '/toots/2-video/');
                            }
                        }
                    }
                />
                <div>
                    <img
                        src={process.env.PUBLIC_URL + "/assets/images/nav/3.png"}
                        style={{ position: 'absolute', top: '8px', left: '156px' }}
                    />
                </div>
                <img
                    src={process.env.PUBLIC_URL + "/assets/images/nav/1.png"}
                    style={{
                        position: 'absolute',
                        top: '-2px',
                        left: '175px',
                        cursor: 'pointer',
                        display: page === 3 ? 'none' : 'block',
                    }}
                    className='inflateButtonMore'
                    onClick={
                        () => {
                            pauseAll();
                            //next
                            if (page === 1) {
                                window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur' + '/toots/2-video/';
                                //navigate(process.env.PUBLIC_URL + '/toots/2-video/');
                            }
                            else if (page === 2) {
                                window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur' + '/toots/3-motives/';
                                //navigate(process.env.PUBLIC_URL + '/toots/3-motives/');
                            }
                        }
                    }
                />

            </div>
        </>

    );
}

export default Toots;
